import { render, staticRenderFns } from "./NewTime.vue?vue&type=template&id=36995273&scoped=true"
import script from "./NewTime.vue?vue&type=script&lang=js"
export * from "./NewTime.vue?vue&type=script&lang=js"
import style0 from "./NewTime.vue?vue&type=style&index=0&id=36995273&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36995273",
  null
  
)

export default component.exports